import React, { useEffect } from "react";

import Provider from "@components/Provider";

import useAuth from "@hooks/useAuth";
import useDeviceInfo from "@hooks/useDeviceInfo";
import useFeatureFlag from "@hooks/useFeatureFlag";
import { addSugarcubeListener } from "@helpers/SugarcubeMessage";

import useEvent from "@hooks/useEvent";
import sentryClient from "@utils/sentry";
import { handleSugarcubeEvent } from "@helpers/SugarcubeAnalytics";
import { setResumeParameter } from "@helpers/SugarcubeNavigation";

export const Bootstrapper = ({ children }) => {
  const { getSessionContext } = useAuth();
  const {
    getMeasurements,
    getDeviceType,
    getMobileOS,
    getCookieConsent,
    getGAUserId,
  } = useDeviceInfo();
  const { getFeatureFlags } = useFeatureFlag();
  const { dispatch } = useEvent();

  const handleResize = () => {
    getMeasurements();
  };

  useEffect(() => {
    sentryClient.init();

    getDeviceType();
    getMobileOS();
    getMeasurements();
    getCookieConsent();
    getSessionContext();
    getFeatureFlags();
    getGAUserId();

    window.testMe = setResumeParameter;

    window.addEventListener("resize", handleResize);
    const sugarcubePubsub = addSugarcubeListener();
    sugarcubePubsub.sub(handleSugarcubeEvent(dispatch));
  }, []);

  return <>{children}</>;
};

const ProviderWithBootstrapper = ({ children }) => (
  <Provider>{children}</Provider>
);

export default ProviderWithBootstrapper;
